import { useEffect, useState } from "react";
import useWPAjaxQuery from "./../../../utils/hooks/useWPAjaxQuery";
import useWPAjaxMutation from "./../../../utils/hooks/useWPAjaxMutation";

const Frontend = () => {
  const { data, isLoading } = useWPAjaxQuery(bData.ajaxURL, {
    method: "getDesignData",
    action: "vstr_ajax",
    token: bData.nonce,
  });
  const { heading, description, buttons, enabled = false, CSS, pages } = data || {};
  const [preview, setPreview] = useState(localStorage.getItem("vstr_preview"));
  const [show, setShow] = useState(false);
  const { isAdmin } = window.bData || {};

  const { saveData, isLoading: dataSaving } = useWPAjaxMutation(bData.ajaxURL, {
    method: "updateFeedback",
    action: "vstr_ajax",
    token: bData.nonce,
  });

  useEffect(() => {
    if (!isLoading && ((enabled && !localStorage.getItem("popup-shown")) || preview)) {
      setTimeout(() => {
        document.addEventListener("click", exit);
        document.addEventListener("keydown", exit);
        document.addEventListener("mouseout", mouseEvent);
      }, 10);
    }

    () => {
      document.removeEventListener("click", exit);
      document.removeEventListener("keydown", exit);
      document.removeEventListener("mouseout", mouseEvent);
    };
  }, [isLoading]);

  const exit = (e) => {
    const shouldExit =
      [...e.target.classList].includes("vstr-exit-intent-popup") || // user clicks on mask
      e.target.className === "close" || // user clicks on the close icon
      e.keyCode === 27; // user hits escape

    if (shouldExit) {
      !preview && saveData({ feedback: "Popup closed" });
      document.querySelector(".vstr-exit-intent-popup")?.classList.remove("visible");
    }
  };

  const mouseEvent = (e) => {
    if (!e.toElement && !e.relatedTarget) {
      !preview && saveData({ feedback: "Popup viewed" });
      document.removeEventListener("mouseout", mouseEvent);
      if (document.querySelector(".vstr-exit-intent-popup")) {
        if (!isAdmin) {
          localStorage.setItem("popup-shown", true);
        }
        document.querySelector(".vstr-exit-intent-popup")?.classList.add("visible");
      }
    }
  };

  useEffect(() => {
    setShow(!pages?.trim()?.length);
    pages?.split("\n")?.map((page) => {
      if (window.location.href.includes(page) && page !== "") {
        setShow(true);
      }
    });
    console.log({ data });
  }, [data]);

  if (!enabled || !show) {
    return <></>;
  }

  return (
    <div className="vstr-exit-intent-popup" id="vstr_visitor_feedback">
      <style>{CSS}</style>
      <div className="popup">
        <div className="close">&times;</div>
        <b className="heading">{heading}</b>
        <p className="text">{description}</p>
        <div className="form">
          {buttons?.map((feedback, index) => (
            <button
              key={index}
              className="submit"
              onClick={() => {
                saveData({ feedback });
                setTimeout(() => {
                  document.querySelector(".vstr-exit-intent-popup")?.classList.remove("visible");
                }, 700);
              }}
              disabled={dataSaving}
            >
              {feedback}
            </button>
          ))}
        </div>
        {/* {dataSaving && (
          <div className="simple_loader">
            <SimpleLoader height="20px" width="20px" />
          </div>
        )} */}
      </div>
    </div>
  );
};

export default Frontend;
